import { AppState, Auth0Provider, withAuthenticationRequired } from '@auth0/auth0-react'
import { theme } from '@busie/ui-kit'
import { env } from '@busie/utils'
import { ThemeProvider } from '@mui/material/styles'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { CircularProgress } from '@busie/ui-kit'
import Box from '@mui/material/Box'
import { Pathfinder } from '~/pages'
import '~/styles/index.css'

const onRedirectCallback = (appState: AppState | undefined) => {
  console.log('[Auth0] onRedirectCallback triggered with appState:', appState)
  console.log('[Auth0] Current URL:', window.location.href)
  console.log('[Auth0] URL has auth params:', {
    hasCode: window.location.search.includes('code='),
    hasState: window.location.search.includes('state='),
    hasError: window.location.search.includes('error='),
  })

  // Default to pathname if no returnTo
  const targetUrl = appState?.returnTo || '/'

  console.log('[Auth0] Will navigate to:', targetUrl)

  // Important: Use window.location.replace to ensure clean navigation
  // This prevents the browser from keeping the auth params in history
  setTimeout(() => {
    console.log('[Auth0] Executing navigation to:', targetUrl)
    window.location.replace(targetUrl)
  }, 0)
}

const ProtectedPathfinder = withAuthenticationRequired(Pathfinder, {
  onRedirecting: () => (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
      }}
    >
      <CircularProgress size={40} />
    </Box>
  ),
})

export function App() {
  return (
    <Auth0Provider
      domain={env.VITE_BUSIE_AUTH_DOMAIN}
      clientId={env.VITE_BUSIE_CLIENT_ID}
      redirectUri={window.location.origin}
      onRedirectCallback={onRedirectCallback}
    >
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<ProtectedPathfinder />} />
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
    </Auth0Provider>
  )
}

export default App
